// extracted by mini-css-extract-plugin
module.exports = {"opaqueBackground":"opaqueBackground___1gwsQ","container":"container___2AB_I","content":"content___2kl1K","dots":"dots___uIvgz"};